/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the functions list at `/connections/functions/$functionId`
 * with the editor sheet auto-opened for the deep-linked function.
 * The Codex full-baseline IA inventory expected this path; the
 * existing `/connections/functions` list view (still the canonical
 * route) handles the rest.
 *
 * The editor sheet seeds from the URL via FunctionsPage's
 * `initialFunctionId` prop. Unknown ids fall through silently to the
 * regular list (no fake "function not found" page — the user just
 * sees the list).
 */

import { createFileRoute } from '@tanstack/react-router';
import { FunctionsPage } from './functions';

export const Route = createFileRoute('/connections/functions/$functionId')({
  component: FunctionDetailAliasRoute,
});

function FunctionDetailAliasRoute() {
  const { functionId } = Route.useParams();
  return <FunctionsPage initialFunctionId={functionId} />;
}
